import Axios from "axios";
import {
  SET_ROSTER_LIST,
  UNSET_ROSTER_LIST
} from "@/store/mutation-types";
import { rosterResource } from "@/store/api";

// Initial State
const state = {
  getRosterList: [],
};

// Getters
const getters = {
  getRosterList(state) {
    return state.getRosterList;
  },
};

// Mutations
const mutations = {
  [SET_ROSTER_LIST](state, data) {
    state.getRosterList = data;
  },
  [UNSET_ROSTER_LIST](state) {
    state.getRosterList = [];
  },
};

// Actions
const actions = {
  // GET LIST
  getRosterList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(rosterResource)
        .then((response) => {
          commit(SET_ROSTER_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_ROSTER_LIST);
          reject(error);
        });
    });
  },

  // CREATE
  saveRoster({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(rosterResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // UPDATE
  updateRoster({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });
    const url = `${rosterResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

getRosterById({ commit }, { id }) {
    commit("SET_LOADING", { color: "primary" });

    const url = `${rosterResource}/${id}`;

    return new Promise((resolve, reject) => {
    Axios.get(url)
        .then((response) => {
        resolve(response);
        })
        .catch((error) => {
        reject(error);
        })
        .finally(() => {
        commit("UNSET_LOADING");
        });
    });
},

};

export default {
  state,
  getters,
  mutations,
  actions,
};
